import { Grid } from '@mui/material';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useStores } from '../../../stores';

export interface DateType {
  startDate: string;
  endDate: string;
}

export interface CustomDateSelectionDropdownProps {
  setSelectedDates: React.Dispatch<React.SetStateAction<DateType>>;
  availableDates: DateType[];
}

const CustomDateSelectionDropdown: React.FC<CustomDateSelectionDropdownProps> = ({
  setSelectedDates,
  availableDates,
}) => {
  const fiscalControlStore = useStores().fiscalControlStore;

  const [options, setOptions] = useState<string[]>([]);
  const [values, setValues] = useState<string[]>([]);
  const [dropdownValue, setDropdownValue] = useState('');

  const handleDateChange = (event: any) => {
    const value = event.target.value as string;
    setDropdownValue(value);

    const { startDate, endDate } = JSON.parse(value);
    fiscalControlStore.setStartDate(startDate);
    fiscalControlStore.setEndDate(startDate);
    setSelectedDates({ startDate, endDate });

    fiscalControlStore.setSelectedDateRange(value);
  };

  useEffect(() => {
    if (availableDates?.length) {
      const newOptions = availableDates.map(({ startDate, endDate }) => {
        const start = moment(startDate).format('MMMM YYYY');
        const end = moment(endDate).format('MMMM YYYY');
        return `${start} - ${end}`;
      });

      const newValues = availableDates.map(({ startDate, endDate }) =>
        JSON.stringify({ startDate, endDate }),
      );

      setOptions(newOptions);
      setValues(newValues);

      if (fiscalControlStore.selectedDateRange) {
        setDropdownValue(fiscalControlStore.selectedDateRange);

        const { startDate, endDate } = JSON.parse(
          fiscalControlStore.selectedDateRange,
        );
        fiscalControlStore.setStartDate(startDate);
        fiscalControlStore.setEndDate(endDate);

        setSelectedDates({ startDate, endDate });
      }
    }
  }, [availableDates]);

  return (
    <Grid>
      <Dropdown
        label={
          availableDates.length > 0 ? 'Select Date Range' : 'No dates available'
        }
        dropDownOptions={options}
        dropDownValues={values}
        value={dropdownValue}
        setValue={setDropdownValue}
        handleChange={handleDateChange}
        width="300px"
        selectStyles={{ width: '300px' }}
      />
    </Grid>
  );
};

export default CustomDateSelectionDropdown;
